<template>
    <div name="auth">
        <loading v-if="isLoading" />
    </div>
</template>

<script>
import axios from 'axios';
import Loading from '@/components/molecules/Loading';

export default {
    name: 'auth',
    data: function()
    {
        return {
            code: '',
            state: '',
            isLoading: true
        }
    },
    components: {Loading},
    mounted: function()
    {
        this.code = this.$route.query.code;
        this.state = this.$route.query.state;
        this.getKakaoToken(this.code)
    },
    methods: {
        getKakaoToken: function(code){
            axios({
                method: 'post',             
                params: {
                    client_id: process.env.KAKAO_REST_API_KEY,
                    code,
                    grant_type: 'authorization_code',
                    client_secret: 'b0uugijyUxs3huf6OPLGO5lQOysyyR9o'   // test
                },
                url: 'https://kauth.kakao.com/oauth/token',
                withCredentials: false,

            }).then((response) => {

                axios ({
                    method: 'get',
                    url: 'https://kapi.kakao.com/v1/user/access_token_info',
                    headers: {
                        'Authorization': `Bearer ${response.data.access_token}`
                    }
                })
                .then((response2) => {
                    // alert(JSON.stringify(response2.data.id))
                    if(this.state.indexOf("/sleepq?ref=") > -1)
                    {
                        window.location.href = `${this.state}&kakao=${response2.data.id}`; 
                    }
                    else
                    {
                        window.location.href = `${this.state}?kakao=${response2.data.id}`; 
                    }
                    
                    
                })


            }).catch((err) => {
                // alert(JSON.stringify(err))
                // console.log("error")
            })
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/Auth.vue